/**
 * @generated SignedSource<<12694bc0dfd3b3a08de7603ca06aa50a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateStudentTargetFocusesInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  createStudentTargetFocusInputs: ReadonlyArray<CreateStudentTargetFocusInput>;
};
export type CreateStudentTargetFocusInput = {
  otherTargetsBlocked: boolean;
  targetId: string;
  userId: string;
};
export type StudentTargetFocusCreateMutation$variables = {
  input: CreateStudentTargetFocusesInput;
};
export type StudentTargetFocusCreateMutation$data = {
  readonly createStudentTargetFocuses: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly studentTargetFocusNode: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
    }> | null | undefined;
  };
};
export type StudentTargetFocusCreateMutation = {
  response: StudentTargetFocusCreateMutation$data;
  variables: StudentTargetFocusCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateStudentTargetFocusesPayload",
    "kind": "LinkedField",
    "name": "createStudentTargetFocuses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentTargetFocusNode",
        "kind": "LinkedField",
        "name": "studentTargetFocusNode",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d34edea640742381c1673422d8de442",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusCreateMutation",
    "operationKind": "mutation",
    "text": "mutation StudentTargetFocusCreateMutation(\n  $input: CreateStudentTargetFocusesInput!\n) {\n  createStudentTargetFocuses(input: $input) {\n    studentTargetFocusNode {\n      id\n      isActive\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b0a1e851b72f468cb5fccb2c1e08226";

export default node;
